module.exports = __webpack_public_path__ + "static/media/star-white.42a3ef69.svg";